import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { CommonApiService } from "src/app/services/common-api.service";
import { first } from "rxjs/operators";

@Component({
  selector: "app-appliance-details",
  templateUrl: "./appliance-details.component.html",
  styleUrls: ["./appliance-details.component.scss"],
})
export class ApplianceDetailsComponent implements OnInit {
  appliance: any;
  serviceData: any;
  appliance_id: any;
  loader: boolean = false;
  constructor(
    public router: Router,
    public api: CommonApiService,
    private route: ActivatedRoute
  ) {
    // this.appliance = this.router.getCurrentNavigation().extras.state;
  }
  public currentStep = 0;
  ngOnInit(): void {
    this.loader = true;
    this.appliance_id = this.route.snapshot.params["appliance_id"];
    this.api
      .getapplianceById(this.appliance_id)
      .pipe(first())
      .subscribe((res) => {
        this.loader = false;
        this.appliance = res;
      });

    this.api
      .getServiceHistory(this.appliance_id)
      .pipe(first())
      .subscribe((res) => {
        this.loader = false;
      });

    this.api
      .diagnosisDataGet(this.appliance_id)
      .pipe(first())
      .subscribe((res) => {
        this.loader = false;
      });
  }

  gotoStep(stepNumber) {
    // form valid for current step
    let valid = true;
    if (valid) {
      this.currentStep = stepNumber;
    }
  }
}
